import axios from 'axios';
import Product from '@/classes/Product';
import ProductInterface from '@/interfaces/ProductInterface';
import { getCookie } from '@/helpers';
import CartInterface from '@/interfaces/CartInterface';

class CartAPI {
  static get(): Promise<CartInterface> {
    return new Promise((resolve, reject) => {
      let { ajaxUrl } = window.ioappConfig;
      const { protocol } = window.location;

      if (protocol !== 'https:') {
        ajaxUrl = ajaxUrl.replace('https://', 'http://');
      }

      axios.get(`${ajaxUrl}?action=cart`, {
        params: {
          endpoint: 'get',
          cartKey: getCookie('io_shop_cart'),
        },
      }).then((response) => {
        const cartData = response?.data?.data?.cartData;
        Object.keys(cartData.commodity).forEach((cartItemKey) => {
          cartData.commodity[cartItemKey].product = new Product(cartData.commodity[cartItemKey].product as ProductInterface);
        });
        resolve(cartData as CartInterface);
      }).catch((e) => {
        reject(e);
      });
    });
  }

  static add(product: Product): Promise<{
    cartData: CartInterface,
    cartEnabled: boolean,
    cartKey: string,
  }> {
    return new Promise((resolve, reject) => {
      let { ajaxUrl } = window.ioappConfig;
      const { protocol } = window.location;

      if (protocol !== 'https:') {
        ajaxUrl = ajaxUrl.replace('https://', 'http://');
      }

      axios.post(`${ajaxUrl}?action=cart`, {
        endpoint: 'add',
        cartKey: getCookie('io_shop_cart'),
        product: product.attributes,
      }).then((response) => {
        const cartData = response?.data?.data?.cartData as { commodity: Record<string, { product: ProductInterface | Product }>};
        Object.keys(cartData.commodity).forEach((cartItemKey) => {
          cartData.commodity[cartItemKey].product = new Product(cartData.commodity[cartItemKey].product as ProductInterface);
        });

        resolve({
          cartData: cartData as CartInterface,
          cartEnabled: (response?.data?.data?.cartEnabled || false) as boolean,
          cartKey: (response?.data?.data?.cartKey || '') as string,
        });
      }).catch((e) => {
        reject(e);
      });
    });
  }

  static remove(itemKey: string, product: Product): Promise<{
    cartData: CartInterface,
    cartEnabled: boolean,
    cartKey: string,
  }> {
    return new Promise((resolve, reject) => {
      let { ajaxUrl } = window.ioappConfig;
      const { protocol } = window.location;

      if (protocol !== 'https:') {
        ajaxUrl = ajaxUrl.replace('https://', 'http://');
      }

      axios.post(`${ajaxUrl}?action=cart`, {
        endpoint: 'remove',
        cartKey: getCookie('io_shop_cart'),
        itemKey,
        type: product.productType,
      }).then((response) => {
        const cartData = response?.data?.data?.cartData as { commodity: Record<string, { product: ProductInterface | Product }>};
        Object.keys(cartData.commodity).forEach((cartItemKey) => {
          cartData.commodity[cartItemKey].product = new Product(cartData.commodity[cartItemKey].product as ProductInterface);
        });

        resolve({
          cartData: cartData as CartInterface,
          cartEnabled: (response?.data?.data?.cartEnabled || false) as boolean,
          cartKey: (response?.data?.data?.cartKey || '') as string,
        });
      }).catch((e) => {
        reject(e);
      });
    });
  }

  static hasCartCookie(): boolean {
    return `${getCookie('io_shop_cart')}`.trim() !== '';
  }
}

export default CartAPI;
